import {AfterViewChecked, Component, EventEmitter, Input, Output} from '@angular/core';
import {AuthService} from "../../services/auth.service";
import {Router} from "@angular/router";
import {DialogService} from "../../services/dialog.service";
import {FilterDataService} from "../../services/filter-data.service";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements AfterViewChecked {

  @Input() isMobileMenuClosed!: boolean;
  @Input() isMobile!: boolean;
  @Input() pageTitle!: string;
  @Input() isFilterPage!: boolean;
  @Output() filterData: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() toggleSidebarEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() mobileMenuCloseEvent: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    private readonly authService: AuthService,
    private readonly router: Router,
    private readonly dialogService: DialogService,
    private readonly filterDataService: FilterDataService
  ) {
  }

  ngAfterViewChecked() {
    this.filterDataService.filterData$.subscribe({
        next: (isPrevPage: boolean) => {
          this.isFilterPage = isPrevPage;
        }
      }
    )
    this.filterDataService.setFilterData(this.isFilterPage);
    this.filterData.emit(this.isFilterPage);
  }

  logout() {
    this.authService.logout();
    this.router.navigate(["/"]);
  }

  mobileMenuCloseAndOpen() {
    this.isMobileMenuClosed = !this.isMobileMenuClosed;
    this.mobileMenuCloseEvent.emit(this.isMobileMenuClosed);
  }

  openQuizGenerationModal() {
    this.dialogService.openQuizGenerationDialog();
  }

  prevPage() {
    this.isFilterPage = false;
    this.filterDataService.setFilterData(this.isFilterPage);
    this.filterData.emit(this.isFilterPage);
    this.router.navigate(["/results-database"]);
  }

  navigateToQuizCreation() {
    this.router.navigate(['/quiz/add']);
  }
}
